<template>
  <div class="page-content">
    <div class="card">
      <CustomIcon :name="content.image" class="card-image" />
      <div class="card-header">
        <h1 class="card-header-title small">{{ content.title }}</h1>
        <p class="card-header-description">{{ content.description }}</p>
      </div>
      <CustomButton
        v-if="content.continue_button_label || content.default_progression"
        variation="primary"
        :onClick="action"
      >
        {{ content.continue_button_label || "Continue" }}
      </CustomButton>
    </div>
  </div>
</template>
<script>
import CustomIcon from "@/components/CustomIcon.vue";
import CustomButton from "@/components/CustomButton.vue";
export default {
  components: {
    CustomIcon,
    CustomButton,
  },
  props: {
    action: {
      type: Function,
      required: true,
    },
    content: {
      type: Object,
      required: true,
      default: () => ({
        content: String,
        description: String,
        image: String,
      }),
    },
  },
};
</script>
